<template>
  <div class="progress-indication">
    <div class="content">
      <div class="description">{{ description }}</div>
      <progress-step :step-completed="true" step-name="הרשמה לשירות"></progress-step>
      <progress-step :step-completed="true" step-name="חיבור חשבונות הבנק והאשראי"></progress-step>
      <progress-step :step-number="'3'" step-name="קבלת תזרים חודשי ראשון!"></progress-step>
    </div>
    <div class="button-wrapper">
      <riseup-button class="button" :title="'קחו אותי לתזרים שלי'" :action="nextStep" :size="'small'"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import ProgressStep from '../../../../../base-components/onboarding/ProgressStep.vue';
import Segment from '../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('ProgressStep3Entered');
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
    ProgressStep,
  },
  name: 'ProgressIndication2',
  computed: {
    ...mapGetters('session', ['firstName']),
    description() {
      return 'מצוין, על בסיס ההגדרות שלך המערכת תחשב לך עכשיו את התזרים החודשי הראשון!';
    },
  },
  methods: {
    ...mapActions('onboardingState', ['progressIndicationTwoSubmit']),
    nextStep() {
      Segment.trackUserInteraction('ProgressStep3NextClicked');
      this.progressIndicationTwoSubmit();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .progress-indication {
    @include white-page-frame;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .content {
      .description {
        width: 100%;
        @include responsive-padding;
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #2dc05c;
        color: $riseup_white;
        font-size: 22px;
        line-height: 1.27;
        font-family: SimplerPro;
        font-weight: bold;
      }
    }

    .button-wrapper {
      width: 100%;
      @include responsive-padding;
      @include responsive-padding-top-bottom;

      .button {
        width: 100%;
      }
    }
  }

</style>
